<template>
  <div class="release-gate-wrapper">
    <div id="root"></div>
  </div>
</template>

<script>
export default {
  name: "ReleaseGateComponent",
  mounted() {
    this.loadCSS('/coding/release-gate/assets/index-Dipdn4yQ.css');
    this.loadJS('/coding/release-gate/assets/index-DzMIdAo0.js');
  },
  beforeDestroy() {
    const root = document.getElementById('root');
    if (root) root.innerHTML = '';
    const css = document.querySelector('link[href*="release-gate/assets/index-"]');
    if (css) css.remove();
    const script = document.querySelector('script[src*="release-gate/assets/index-"]');
    if (script) script.remove();
  },
  methods: {
    loadCSS(href) {
      if (!document.querySelector('link[href*="release-gate/assets/index-"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    },
    loadJS(src) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = src + '?t=' + Date.now();
      document.head.appendChild(script);
    }
  }
}
</script>

<style scoped>
.release-gate-wrapper {
  width: 100%;
}
</style>
